import styled from "styled-components";
import { Colors } from "../../../config/Constants";
import Button from "../../Button";
import Selectfield from "../../Merchant/Selectfield";
import Modal from "../../Modal";
import Textfield from "../../Merchant/Textfield";
import { ChangeEvent, useState } from "react";

interface Props {
  setOpenOrClose: (a: boolean) => void;
  handleCloseClick: () => void;
  paymentModes: (
    | { label: string; value: string }
    | { label: string; value: number }
  )[];
  paymentData: {
    paymentMode: string;
    chequeNumber: string;
    cashAmount: string;
  };
  paymentDataError: {
    paymentMode: string;
  };
  handleChange: (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => void;
  handleContinueClick: () => void;
  modalHeader?: string;
  isRequiredInputfield?: boolean;
  buttonLabel?: string;
  paymentInputFieldError?: string;
  isButtonLabelChange?: boolean;
}

const PaymentDetailsModal = ({
  setOpenOrClose,
  handleCloseClick,
  paymentModes,
  paymentData,
  paymentDataError,
  handleChange,
  handleContinueClick,
  modalHeader,
  isRequiredInputfield,
  buttonLabel,
  paymentInputFieldError,
  isButtonLabelChange,
}: Props) => {
  const [isDataFilled, setIsDataFilled] = useState("");
  const labelCondition = isButtonLabelChange
    ? isDataFilled !== ""
      ? "Payment Received"
      : "Continue"
    : buttonLabel;

  const handleChequeCashChange = (
    e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>
  ) => {
    handleChange(e);
    setIsDataFilled(e.target.value);
  };

  return (
    <Modal setOpenOrClose={setOpenOrClose} variant="none" width="21.2rem">
      <StyledPaymentDetail>
        <PaymentDetailHeader>
          <HeaderTitle>
            {modalHeader ? modalHeader : "Payment Details"}
          </HeaderTitle>
          <Close
            src={require("../../../assets/images/ei_close.png")}
            alt="close"
            onClick={handleCloseClick}
          />
        </PaymentDetailHeader>
        <PaymentDetailBody>
          <Label>
            Payment Mode<span>*</span>
          </Label>
          <Selectfield
            data={paymentModes}
            name="paymentMode"
            value={paymentData.paymentMode}
            onChange={handleChange}
            required
            helperText={paymentDataError["paymentMode"]}
          />
          {paymentData.paymentMode === "cheque" && (
            <>
              <Label>
                Cheque Number{isRequiredInputfield && <span>*</span>}
              </Label>
              <Textfield
                placeholder="Enter Cheque Number"
                name="chequeNumber"
                value={paymentData.chequeNumber}
                onChange={handleChequeCashChange}
                helperText={paymentInputFieldError && paymentInputFieldError}
              />
            </>
          )}
          {paymentData.paymentMode === "cash" && (
            <>
              <Label>Cash Amount{isRequiredInputfield && <span>*</span>}</Label>
              <Textfield
                placeholder="Enter Cash Amount Received"
                name="cashAmount"
                value={paymentData.cashAmount}
                onChange={handleChequeCashChange}
                helperText={paymentInputFieldError && paymentInputFieldError}
              />
            </>
          )}
          <ButtonWrapper>
            <Button
              label={labelCondition}
              variant="filled"
              color={Colors.solidRed}
              size="medium"
              isRounded={true}
              onClick={handleContinueClick}
            />
          </ButtonWrapper>
        </PaymentDetailBody>
      </StyledPaymentDetail>
    </Modal>
  );
};

const StyledPaymentDetail = styled.div`
  padding: 1.625rem 2.2rem 1.8rem 2.25rem;
`;

const PaymentDetailHeader = styled.div`
  display: flex;
  justify-content: center;
`;

const HeaderTitle = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.mineShaft};
`;

const Close = styled.img`
  transform: translate(4.375rem, -0.25rem);
  cursor: pointer;
`;

const PaymentDetailBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonWrapper = styled.div`
  margin-top: 1.5rem;
`;

const Label = styled.label`
  font-family: "Poppins-Medium";
  font-size: 0.8rem;
  color: ${Colors.comet};
  margin-top: 1.56rem;
  margin-bottom: 0.625rem;
  > span {
    color: ${Colors.red};
    margin-left: 2px;
  }
`;

export default PaymentDetailsModal;
